import React, { useState } from "react";
import { connect } from "react-redux";
import { TabPanel, Item as TabItem } from "devextreme-react/tab-panel";
import CustomerItems from "./CustomerItems";
import CustomerLots from "./CustomerLots";
import CustomerSerialNumbers from "./CustomerSerialNumbers";

// Item Master = the customer's items with three sub-tabs (Items / Lots / Serial Number).
// Items uses wm/Item/GetAllItems; selecting an item drives the Lots sub-tab
// (wm/Lot/GetAllLots by item). Serial Number is a placeholder for now.
const ItemMasterTab = (props) => {
    const [selectedItemId, setSelectedItemId] = useState(null);

    return (
        <TabPanel>
            <TabItem title="Items">
                <CustomerItems
                    customerId={props.id}
                    gridKey="0F3A1B62-7C4D-4E85-9A16-2D7B0C53F8E1"
                    onItemSelected={setSelectedItemId}
                />
            </TabItem>
            <TabItem title="Lots">
                <CustomerLots
                    itemRowId={selectedItemId}
                    gridKey="1B4C2D73-8E5F-4A96-B027-3E8C1D64F9A2"
                />
            </TabItem>
            <TabItem title="Serial Number">
                <CustomerSerialNumbers
                    itemRowId={selectedItemId}
                    gridKey="2C5D3E84-9F60-4B17-A138-4F9D2E75C0B3"
                />
            </TabItem>
        </TabPanel>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ItemMasterTab);
